'use client'

import { useState } from "react"
import { ChevronDown, FileText, Clock, ExternalLink } from 'lucide-react'
import Link from "next/link"

const completedCases = [
    {
        caseNumber: 'А53-26840/2025',
        city: 'г. Ростов-на-Дону',
        completedDate: '19.02.2026',
        debtAmount: '265 826 руб.',
        startDate: '21.07.2025',
        filingDate: '28.07.2025',
        bankruptDate: '30.09.2025',
        pdfUrl: 'https://bankrotconsult.ru/wp-content/uploads/case/2026/3/30/A53-26840-2025_20260219_Opredelenie.pdf',
        courtUrl: 'https://kad.arbitr.ru/Document/Pdf/1b5efc61-88b9-493c-ba46-cadff54bfb2c/b2df9545-989e-45ec-9b42-26a90ffd3567/A53-26840-2025_20260219_Opredelenie.pdf',
    },
    {
        caseNumber: 'А81-6553/2025',
        city: 'г. Салехард',
        completedDate: '09.02.2026',
        debtAmount: '683 644 руб.',
        startDate: '07.07.2025',
        filingDate: '14.07.2025',
        bankruptDate: '28.07.2025',
        pdfUrl: 'https://bankrotconsult.ru/wp-content/uploads/case/2026/3/30/A81-6553-2025_20260209_Opredelenie.pdf',
        courtUrl: 'https://kad.arbitr.ru/Document/Pdf/aadb35e3-0b22-4376-8a86-bafd86b852e6/89c7f79b-2d32-4310-ae8b-2e486bb9abf8/A81-6553-2025_20260209_Opredelenie.pdf',
    },
    {
        caseNumber: 'А40-288360/2024',
        city: 'г. Москва',
        completedDate: '18.12.2025',
        debtAmount: 'более 500 000 руб.',
        startDate: '22.11.2024',
        filingDate: '29.11.2024',
        bankruptDate: '14.02.2025',
        pdfUrl: 'https://bankrotconsult.ru/wp-content/uploads/2026/01/A40-288360-2024_20251218_Opredelenie.pdf',
        courtUrl: 'https://kad.arbitr.ru/Document/Pdf/e843e968-2732-4c1f-9459-82033b8ace82/5d52853d-d1a5-44ee-8234-427a77208df7/A40-288360-2024_20251218_Opredelenie.pdf',
    },
    {
        caseNumber: 'А41-110198/2024',
        city: 'г. Москва',
        completedDate: '16.12.2025',
        debtAmount: 'более 500 000 руб.',
        startDate: '30.11.2024',
        filingDate: '06.12.2024',
        bankruptDate: '14.02.2025',
        pdfUrl: 'https://bankrotconsult.ru/wp-content/uploads/case/2026/2/23/dfkpqpd6xn.pdf',
        courtUrl: 'https://kad.arbitr.ru/Document/Pdf/c678b909-1561-4b43-958a-7f28abbc9eb5/936875d4-3ea1-4ad0-b324-78bc4cde6f73/A41-110198-2024_20251216_Opredelenie.pdf',
    },
    {
        caseNumber: 'А48-13815/2024',
        city: 'г. Орёл',
        completedDate: '12.11.2025',
        debtAmount: '603 849 руб.',
        startDate: '25.11.2024',
        filingDate: '02.12.2024',
        bankruptDate: '05.03.2025',
        pdfUrl: 'https://bankrotconsult.ru/wp-content/uploads/2026/02/A48-13815-2024_20251212_Opredelenie.pdf',
        courtUrl: 'https://kad.arbitr.ru/Document/Pdf/3a3adc12-1b53-4345-8f2a-5c65ab4412c3/d59f16ee-01bd-43a7-8aca-aae8b8cecaa7/A48-13815-2024_20251212_Opredelenie.pdf',
    },
    {
        caseNumber: 'А40-288949/2024',
        city: 'г. Москва',
        completedDate: '11.12.2025',
        debtAmount: '754 753 руб.',
        startDate: '25.11.2024',
        filingDate: '02.12.2024',
        bankruptDate: '13.02.2025',
        pdfUrl: 'https://bankrotconsult.ru/wp-content/uploads/2026/02/A40-288949-2024_20251204_Opredelenie.pdf',
        courtUrl: 'https://kad.arbitr.ru/Document/Pdf/ceb0844f-975f-44da-865b-f7db74bc9566/28487192-1656-43f3-ad70-161d29caceb6/A40-288949-2024_20251204_Opredelenie.pdf',
    },
]

export const WeHelpedYou = () => {
    const [showAllCases, setShowAllCases] = useState(false)
    const visibleCases = showAllCases ? completedCases : completedCases.slice(0, 3)
    
    return (
        <section className="py-16 px-4 bg-muted/30">
            <div className="container max-w-5xl">
                <h2 className="font-display text-2xl sm:text-3xl font-bold text-center mb-3">Мы помогли Вам и ещё множеству людей</h2>
                <p className="text-muted-foreground text-center mb-10 max-w-2xl mx-auto">Некоторые из наших завершённых дел. Мы публикуем их с разрешения наших клиентов</p>

                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
                    {visibleCases.map((c, i) => (
                        <div key={i} className="bg-card rounded-2xl p-6 card-elevated border border-border flex flex-col">
                            <div className="flex items-center gap-2 mb-3">
                                <FileText className="h-5 w-5 text-primary" />
                                <span className="font-display font-bold text-foreground">№{c.caseNumber}</span>
                            </div>
                            <p className="text-sm text-muted-foreground mb-1">{c.city}</p>
                            <p className="text-sm text-muted-foreground mb-4">Завершено: {c.completedDate}</p>

                            <div className="space-y-2 mb-5 text-sm flex-1">
                                <div className="flex items-center gap-2 text-muted-foreground">
                                    <Clock className="h-3.5 w-3.5 text-secondary shrink-0" />
                                    <span>{c.startDate} — Поступило в работу</span>
                                </div>
                                <div className="flex items-center gap-2 text-muted-foreground">
                                    <Clock className="h-3.5 w-3.5 text-secondary shrink-0" />
                                    <span>{c.filingDate} — Подача заявления</span>
                                </div>
                                <div className="flex items-center gap-2 text-muted-foreground">
                                    <Clock className="h-3.5 w-3.5 text-secondary shrink-0" />
                                    <span>{c.bankruptDate} — Признан банкротом</span>
                                </div>
                            </div>

                            <div className="flex flex-col gap-2 mt-auto">
                                <Link href={c.pdfUrl} target="_blank" rel="noopener noreferrer">
                                    <button className="flex w-full gap-2 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-9 rounded-md px-3 justify-center items-center">
                                        <FileText className="h-4 w-4" /> Посмотреть дело
                                    </button>
                                </Link>
                                <Link
                                    href={c.courtUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-xs text-primary hover:underline flex items-center gap-1 justify-center"
                                >
                                    <ExternalLink className="h-3 w-3" /> Дело на сайте арбитражного суда
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="text-center space-y-3">
                    {!showAllCases && completedCases.length > 3 && (
                        <button
                            className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-background hover:bg-accent hover:text-accent-foreground h-11 rounded-md gap-2 text-base px-8"
                            onClick={() => setShowAllCases(true)}
                        >
                            Показать ещё <ChevronDown className="h-5 w-5" />
                        </button>
                    )}
                    <div>
                        <a href="https://bankrotconsult.ru/completed-casey/" target="_blank" rel="noopener noreferrer">
                            <button className="inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-accent hover:text-accent-foreground h-11 rounded-md gap-2 text-base px-8 text-primary">
                                Все дела на сайте <ExternalLink className="h-4 w-4" />
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}
